import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BackendApi } from '../../services/backend-api';
import { Service } from '../../models/service';
import { UsageRate } from '../../models/usage-rate';
import { MatIconModule } from "@angular/material/icon";
import { TextFieldModule } from '@angular/cdk/text-field';
import { EXCEPTION_TYPES } from '../../models/usage-rate';
import { KeyValuePipe } from '@angular/common';


@Component({
  selector: 'app-create-usage-rate-dialog',
  imports: [MatDialogModule, MatInputModule, MatButtonModule, MatFormFieldModule, ReactiveFormsModule, MatSelectModule, MatSlideToggleModule, MatIconModule, TextFieldModule, KeyValuePipe],
  templateUrl: './create-usage-rate-dialog.html',
  styleUrl: './create-usage-rate-dialog.css',
})
export class CreateUsageRateDialog {
  constructor(
    private readonly backendApi: BackendApi,
    private dialogRef: MatDialogRef<CreateUsageRateDialog>
  ) { }

  private _snackBar = inject(MatSnackBar);
  private formBuilder = inject(FormBuilder);

  public readonly usageRateTypes = [
    {value: null, label: 'Non precisé'},
    {value: "france", label: "Tarif negocié France"},
    {value: "world", label: "Prix monde"}
  ];

  readonly exceptionTypes = EXCEPTION_TYPES;

  public services!: Service[];

  usageRateForm = this.formBuilder.group({
    is_landline: [true],
    name: ['', Validators.required],
    description: ['', Validators.required],
    service: ['Commeett', Validators.required],
    type: new FormControl<null|string>(null),
    is_exception: [false],
    is_default: [false],
  })

  ngOnInit() {
    this.backendApi.getServices().subscribe({
      next: (services) => {
        this.services = services;
      },
      error: () => {
        this._snackBar.open("Erreur rencontrée lors de la recuperation des services.");
      }
    });
  }

  submit() {
    const newUsageRate: UsageRate = this.usageRateForm.value as UsageRate;
    
    this.backendApi.createUsageRate(newUsageRate).subscribe({
      next: (createdUsageRate) => {
        this._snackBar.open("Grille de vente créée.");
        this.dialogRef.close(createdUsageRate);
      },
      error: () => {
        this._snackBar.open("Erreur rencontrée lors de la création de la grille de vente.");
      }
    })
  }
}
